import { PaymentWithAccountantMethod } from "../enums/global.enums";

export function paymentWithAccountantMethodPipe(value: string) {
    switch (value) {
        case PaymentWithAccountantMethod.Debtminusdeposit: return "Gạch nợ trừ cọc";
        case PaymentWithAccountantMethod.Manual: return "Thu trực tiếp";
        case PaymentWithAccountantMethod.Transfer: return "Chuyển khoản ngân hàng";
    }
    return "";
}